







import { Component, Vue } from 'vue-property-decorator';
import { siteConfig } from '@/SiteConfig.ts';

@Component
export default class PageNotFound extends Vue {
  private mainTextColor = siteConfig.mainTextColor;
}
